import script from "./VideoDataNative.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoDataNative.vue?vue&type=script&setup=true&lang=js"

import "./VideoDataNative.vue?vue&type=style&index=0&id=7927ee8c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7927ee8c"]])

export default __exports__